import React from 'react';
import PropTypes from 'prop-types';
import _ from "lodash"
import {isLoaded,isEmpty } from 'react-redux-firebase'
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete'

import {Muted} from "../"


import { withStyles,
    List,
    ListItem,
    Avatar,
    ListItemSecondaryAction,
    ListItemText,
    IconButton
} from '@material-ui/core';


const MemberList = ({...props})=>{

    const {members,invitedUsers,classes,cancelInvite,removeMember,users} = props

        console.log(members,invitedUsers,isLoaded(users))

    return(
        <div className={classes.root}>
        {
        (isLoaded(members) && isLoaded(users) && isLoaded(invitedUsers) || !isEmpty(members) || !isEmpty(invitedUsers))?
        <div>
            {
                (members) ?
                    <List className={classes.list}>
                        {_.map(members, (value,member) => {
                            return (
                                <ListItem key={member}>
                                    <Avatar className={classes.avatar}>{member.charAt(0).toUpperCase()}</Avatar>
                                    <ListItemText primary={users[member]?users[member].email:"This User Does not exist anymore."}/>
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            onPress={()=>{removeMember(member)}}
                                            color="primary" className={classes.iconButton} component="span"
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>

                                </ListItem>
                            )
                        })
                        }
                    </List>
                    :
                    <Muted>There are no members for this organisation</Muted>
            }  
            { 
                 (invitedUsers) ?
                    <List className={classes.list}>
                        {_.map(invitedUsers,(invitedUser,key)=>{
                            return(
                                <ListItem key={key}>
                                    <Avatar className={classes.avatar}>{invitedUser.id.charAt(0).toUpperCase()}</Avatar>
                                    <ListItemText primary={invitedUser.id} secondary={"Pending Invite, waiting for user to create an Ispani account"}/>
                                    <ListItemSecondaryAction>
                                        <IconButton onClick={()=>{cancelInvite(invitedUser.id)}}
                                            color="primary" className={classes.iconButton} component="span"
                                        >
                                            <CloseIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>

                                </ListItem>

                            )
                        })
                        }
                    </List>
                    :
                    <Muted>There are no pending invites for this organisation</Muted>
         }
        </div>
        :
        (!invitedUsers && !members && isEmpty(members) && isEmpty(invitedUsers) && isLoaded(members) && isLoaded(invitedUsers))?
        <div>looading</div> 
        :
        <Muted>There are no members or pending invites for this organisation</Muted>  
        }
        </div>

    )
}

const styles={
    root:{
    },
}

export default withStyles(styles)(MemberList)


// WEBPACK FOOTER //
// ./src/components/MemberList/MemberList.jsx